import React         from 'react';
import classnames    from 'classnames';
import TextComponent from './TextComponent';

const Revision = (props) => {
  const {
    parameters,
    onChangeParameter,
    groupName,
    required,
  } = props;
  const onChange = event => onChangeParameter('revision', event.target.value);
  const value = parameters.get ? parameters.get('revision') : parameters.revision;
  return (
    <TextComponent
      label={props.label}
      name="revision"
      inputId={props.inputId}
      value={value || ''}
      required={required}
      ignoreOnQuote={props.ignoreOnQuote}
      onChange={onChange}
      groupName={groupName}
      className={classnames('revision', props.className)}
      {...props} >
      {props.children}
      </TextComponent>
  );
};

Revision.defaultProps = {
  required     : true,
  ignoreOnQuote: true,
  inputId      : 'revision',
  label        : 'Revision',
};

export default Revision;
